export default __webpack_public_path__ + "static/Ether-Legends-7f5375de7497108b224099628da7515a.webp";